import { cn } from "@productlane/lib/src/cn"
import { ShortcutSymbols } from "@productlane/lib/src/shortcut-symbols"
import { BlockquoteIcon } from "@productlane/ui/src/icons/project/blockquote-icon"

import type { SlashCommandDefinition } from "../types"
import { iconClassName } from "../constants"

export const quoteCommand: SlashCommandDefinition = {
	key: "quote",
	title: "Blockquote",
	icon: (
		<BlockquoteIcon
			className={cn(
				"h-[16px] w-[16px] fill-[#595d5e] stroke-[1.5] dark:fill-[#94a3b8]",
				iconClassName,
			)} //colors should match text-secondary
		/>
	),
	command: ({ editor, range }) => {
		editor.chain().focus().deleteRange(range).setBlockquote().run()
	},
	group: "blocks",
	shortcutIcons: [
		ShortcutSymbols.CMD,
		ShortcutSymbols.SHIFT,
		ShortcutSymbols["."],
	],
}
